<template>
  <b-row>
    <b-col md="12"><h3>Create Concern</h3></b-col>
    <b-col md="12" class="pb-0 pt-0">
      <b-card class="custome-card mb-3">
        <b-row>
          <b-col md="4">
            <b-form-input
              inputType="text"
              placeholder="Enter Concern Name"
              class="mt-0"
              v-model="concernInput"
            />
          </b-col>
          <b-col md="1"></b-col>
          <b-col md="5">
            <b-form-radio-group
              id="radio-group-2"
              v-model="selected"
              class="d-flex"
              name="radio-sub-component"
            >
              <div class="">
                <h4 class="">Concern Type</h4>
              </div>
              <div class="mt-1">
                <b-form-radio value="system" name="radio-size" size="lg">
                  <h4 class="ml-2 mt-1">System</h4>
                </b-form-radio>
              </div>
              <div class="mt-1">
                <b-form-radio value="custom" name="radio-size" size="lg">
                  <h4 class="ml-2 mt-1">Custom</h4>
                </b-form-radio>
              </div>
            </b-form-radio-group>
          </b-col>
          <b-col md="2">
            <button
              type="button"
              class="btn btn-primary w-100"
              classic="mr-1 btn-primary"
              text="Save"
              @click="showCreateConsern"
            >
              Save
            </button>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col md="12" class="pt-0 pb-0 mb-1">
      <b-row>
        <b-col md="5" class="pt-0 pb-0"
          ><h3 class="mt-3 mb-3">Concern List</h3></b-col
        >
        <b-col md="3" class="pt-0 pb-0">
          <eb-select
            type="select"
            v-model="selectConcern"
            :options="options"
            label="text"
            id="valueConcern"
            class="mt-2 mb-2"
            placeholder="Search Type"
            @input="onChangeConcernType"
          ></eb-select>
        </b-col>
        <b-col md="3" class="pt-0 pb-0">
          <div v-if="selectConcern.value == 'name'">
            <Vue-Simple-Suggest
              class="mt-2 mb-2"
              :nullable-select="true"
              v-model="searchConcernInput"
              @keyup.enter.native="searchConcernResult()"
              :debounce="1000"
              display-attribute="name"
              value-attribute="_id"
              placeholder="Search Concern Name"
            ></Vue-Simple-Suggest>
            <button class="text-grey searchIcon" @click="searchConcernResult()">
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>
          <eb-select
            v-else
            type="select"
            v-model="selectConcernType"
            :options="optionsConcern"
            label="text"
            id="valueType"
            class="mt-2 mb-2"
            placeholder="Select Concern Type"
            @input="searchConcernResult"
          ></eb-select>
        </b-col>
        <b-col md="1" class="pt-0 pb-0">
          <div class="text-right mt-2 mb-2">
            <b-button
              size="sm"
              variant="success"
              class="my-2 mr-2 my-sm-0"
              @click="reloadPage"
            >
              <span
                v-if="loading"
                class="fa fa-refresh fa-spin"
                style="font-size: 15px"
              />
              <span v-else class="fa fa-refresh" style="font-size: 15px" />
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col md="12">
      <b-card class="custome-card">
        <div>
          <b-table
            class="tableRadius"
            :dark="dark"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive
            :items="concernOptionData"
            :fields="concernListData"
            :current-page="currentPage"
            :per-page="perPage"
            @filtered="onFilter"
            thead-class="header"
            show-empty
            :busy="loading"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template slot="createdAt" slot-scope="data">
              <div>
                {{
                  moment(String(data.item.createdAt)).format(
                    "DD/MM/YYYY hh:mm A"
                  )
                }}
              </div>
            </template>
            <template slot="action" slot-scope="data">
              <div class="inline_btnTable">
                <b-button
                  size="sm"
                  class="mr-2 butto-circle"
                  variant="danger"
                  @click="deleteConcernlist(data.item)"
                >
                  <i class="fas fa-trash-alt"></i>
                </b-button>
              </div>
            </template>
            <template slot="empty">
              <div v-if="loading" class="text-center">
                <span><b>Loading...</b></span>
              </div>
              <div v-else class="text-center">No data available.</div>
            </template>
          </b-table>
        </div>
        <div style="float: right">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="filterCount"
            aria-controls="my-table"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          ></b-pagination>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import ebSelect from "@/components/FormElements/Select.vue";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import loader from "@/components/loader/nipigeloader.vue";
import Vue from "vue";
import moment from "moment";
Vue.prototype.moment = moment;
export default {
  name: "concern",
  data() {
    return {
      concernInput: "",
      selected: "system",
      filterCount: 0,
      loading: false,
      perPage: 10,
      currentPage: 1,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      sortBy: "createdAt",
      sortDesc: true,
      concernListData: [
        {
          key: "name",
          label: "Concern Name",
        },
        {
          key: "type",
          label: "Concern Type",
        },
        {
          key: "createdAt",
          label: "Created Date",
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      searchConcernInput: "",
      selectConcern: "name",
      options: [
        { text: "Concern Name", value: "name" },
        { text: "Concern Type", value: "type" },
      ],
      selectConcernType: "custom",
      optionsConcern: [
        { text: "System", value: "system" },
        { text: "Custom", value: "custom" },
      ],
    };
  },
  components: {
    loader,
    VueSimpleSuggest,
    ebSelect,
  },
  computed: {
    ...mapState({
      concernOptionData: (state) => state.concern.concernOptionData,
    }),
  },
  methods: {
    onChangeConcernType() {
      this.searchConcernInput = "";
      this.selectConcernType = "";
    },
    async showCreateConsern() {
      if (this.concernInput != "") {
        let payload = {
          name: this.concernInput,
          type: this.selected,
          active: true,
        };
        await this.$store.dispatch("concern/concernCreate", payload);
        this.$swal({
          title: "success!",
          text: "Your Concern is Submitted successfully!",
          type: "success",
        });
        this.reloadPage();
      } else {
        this.$swal({
          title: "Error!",
          text: "Please Enter Concern Name!",
          type: "warning",
        });
      }
    },

    async deleteConcernlist(data) {
      this.$swal({
        title: "Delete this Concern?",
        text: "Are you sure? This will be Remove?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          this.$store
            .dispatch("concern/ConcernDeleteAction", data._id)
            .then((result) => {
              this.$swal({
                type: "success",
                title: "Success",
                text: "Concern Deleted Successfully!",
              });
              this.reloadPage();
              this.loading = false;
            });
        }
      });
    },
    async searchConcernResult() {
      let payload = {
        name: this.searchConcernInput,
        type: this.selectConcernType.value || "",
      };

      await this.$store.dispatch("concern/concernFilterAction", payload);
    },
    async reloadPage() {
      this.loading = true;
      let payload = {
        name: "",
        type: "",
      };
      await this.$store.dispatch("concern/concernFilterAction", payload);
      this.loading = false;
    },
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
  },
  async mounted() {
    this.loading = true;
    let payload = {
      name: "",
      type: "",
    };
    await this.$store.dispatch("concern/concernFilterAction", payload);
    this.loading = false;
  },
};
</script>
<style scoped>
.card.custome-card {
  border: 1px solid #ddd;
  border-radius: 12px;
}
.text-grey {
  color: #aaaa;
  background-color: transparent;
}
</style>
